import React from "react";

import { useContentContext } from "../context/content-context";

const PatientCta = () => {
  const { patientCTA } = useContentContext();

  if (patientCTA) {
    const { text, buttonText, buttonUrl } = patientCTA;
    if (text) {
      return (
        <section class="section-outer background-blue-teal-gradient-horizontal">
          <div class="section-inner column text-align-center">
            <div dangerouslySetInnerHTML={{ __html: text }} />
            <a href={buttonUrl} class="button transparent-white uppercase">
              {buttonText}
            </a>
          </div>
        </section>
      );
    }
  }

  return null;
};

export default PatientCta;
